import { GraduationCap, UserRound, Building2 } from "lucide-react";


const ROLES = [
  { key: "student", label: "Student", desc: "Find teachers, home tuition & institutes. Review and earn points.", icon: GraduationCap, bg: "#A3E635" },
  { key: "teacher", label: "Teacher", desc: "Create your profile, offer home tuition and receive hiring requests.", icon: UserRound, bg: "#FCD34D" },
  { key: "institute", label: "Institute", desc: "List your coaching institute, school or college and find teachers.", icon: Building2, bg: "#FDBA74" },
];

export default function RoleSelect({ onPick, title = "Select your role", compact = false, testPrefix = "role" }) {
  return (
    <div data-testid="role-select" className={compact ? "" : "max-w-3xl mx-auto px-4 sm:px-8 py-12"}>
      {!compact && <><p className="nb-label" style={{ letterSpacing: "0.2em" }}>Get started</p>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight mt-1">{title}</h1></>}
      <div className="grid sm:grid-cols-3 gap-4 mt-8">
        {ROLES.map(({ key, label, desc, icon: Icon, bg }) => (
          <button key={key} data-testid={`${testPrefix}-${key}`} onClick={() => onPick(key)} className="nb p-6 text-left hover:-translate-y-0.5 transition-transform" style={{ background: "#fff" }}>
            <span className="w-12 h-12 rounded-2xl border-2 border-[#171B33] flex items-center justify-center" style={{ background: bg }}><Icon className="w-6 h-6" /></span>
            <p className="font-display text-xl font-extrabold mt-4">{label}</p>
            <p className="text-sm text-slate-600 mt-1">{desc}</p>
          </button>
        ))}
      </div>

    </div>
  );
}
